import { render, staticRenderFns } from "./CreateVideo.vue?vue&type=template&id=2f521d72&scoped=true"
import script from "./CreateVideo.vue?vue&type=script&lang=ts"
export * from "./CreateVideo.vue?vue&type=script&lang=ts"
import style0 from "./CreateVideo.vue?vue&type=style&index=0&id=2f521d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f521d72",
  null
  
)

export default component.exports